export default __webpack_public_path__ + "static/media/camp.c3bc77bd.jpg";